import { React, useState, useEffect } from 'react';
import { strings } from '../localization/strings';

function Summary({ availability, tourName, date, adult, child, baby, nextStep, language, excludeFree }) {
    const [totalPrice, setTotalPrice] = useState(0);
    const [scrollPosition, setScrollPosition] = useState(0);
    const [position, setPosition] = useState(undefined);
    const [leftPosition, setLeftPosition] = useState(0);
    const [offsetTop, setOffsetTop] = useState(undefined);

    const translation = strings[language] ?? strings.it;

    const clickNextStep = () => {
        nextStep();
    };

    useEffect(() => {
        if (availability && availability.tariff) {
            const adultPriceCalc = availability.tariff.adult * adult;
            const childPriceCalc = availability.tariff.reduced * child;
            let total = adultPriceCalc + childPriceCalc;

            if (availability.entranceFee) {
                const entranceFeeCalc = availability.entranceFee.adult * adult + availability.entranceFee.reduced * child;
                total = total + entranceFeeCalc;
            }
            
            // show the total price with 2 decimal digits
            total = total.toFixed(2).replace('.', ',');
            setTotalPrice(total);
        }
    }, [availability, adult, child]);

    useEffect(() => {
        const handleScroll = () => {
            if (offsetTop === undefined) {
                const summaryContainer = document.querySelector('.summary-container');
                setOffsetTop(summaryContainer.offsetTop + summaryContainer.offsetParent.offsetTop + 20);
                return;
            }
            if (window.scrollY < offsetTop) {
                if (position === 'fixed') {
                    setPosition('unset');
                    setScrollPosition(0);
                    setLeftPosition(0);
                }
            } else {
                if (position !== 'fixed') {
                    const summaryContainer = document.querySelector('.summary-container');
                    const offsetLeft = summaryContainer.offsetLeft;

                    setPosition('fixed');
                    setScrollPosition(20);
                    setLeftPosition(offsetLeft);
                }
            }
        };

        const handleResize = (e) => {
            // get current window width
            const windowWidth = e.target.innerWidth;
            if (windowWidth < 999) {
                window.removeEventListener('scroll', handleScroll);
                if (position === 'fixed') {
                    setPosition('unset');
                    setScrollPosition(0);
                    setLeftPosition(0);
                }
            } else {
                if (!window.onscroll) {
                    window.addEventListener('scroll', handleScroll);
                }
            }
        };

        if (window.innerWidth >= 1300) {
            window.addEventListener('scroll', handleScroll);
        }
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleResize);
        };
    }, [offsetTop, position]);

    return (
        <div className="summary-root" style={{position: `${position}`, top: `${scrollPosition}px`, left: `${leftPosition}px`}}>
            <div className="summary-container">
                <div className="summary-top">
                    {translation.summary}
                </div>
                <div className="summary-tour-name">{tourName}</div>
                <div className="summary-tour">
                    <div className="recap-column">
                        <div className="recap-row">
                            <div style={{flex: 2}}>{translation.date}:</div>
                            <div style={{flex: 1}} className="recap-next-sign"><span></span></div>
                            <div style={{flex: 2}}><b>{date}</b></div>
                        </div>
                        <div className="recap-row">
                            <div style={{flex: 2}}>{translation.passengers}:</div>
                            <div style={{flex: 1}} className="recap-next-sign"><span></span></div>
                            <div style={{flex: 2}}><b>{adult}</b> {translation.adultsLowercase}</div>
                        </div>
                        <div className="recap-row">
                            <div style={{flex: 2}}></div>
                            <div style={{flex: 1}}></div>
                            <div style={{flex: 2}}><b>{child}</b> {translation.childrenLowercase}</div>
                        </div>
                        { !excludeFree &&
                            <div className="recap-row">
                                <div style={{flex: 2}}></div>
                                <div style={{flex: 1}}></div>
                                <div style={{flex: 2}}><b>{baby}</b> {translation.infantsLowercase}</div>
                            </div>
                        }
                        <div className="recap-row" style={{height: '24px'}}></div>
                        <div className="recap-row">
                            <div style={{flex: 2}}>{translation.totalShort}:</div>
                            <div style={{flex: 1}} className="recap-next-sign"><span></span></div>
                            <div style={{flex: 2}}><b>{totalPrice}€</b></div>
                        </div>
                    </div>
                    { nextStep &&
                    <a className="tourmaster-button" style={{borderRadius: '20px', marginTop: '20px', width: '100%', textAlign: 'center'}} onClick={clickNextStep}>
                        {translation.personalDataCallToAction} <span className="fa fa-solid fa-chevron-right" style={{marginLeft: '10px'}}></span>
                        </a>
                    }
                </div>
            </div>
        </div>
    );
}

export default Summary;